import {useIsOrgUnitPilot} from "../services/auth"

// Default to "Local" to keep local dev usable even when ENV_NAME isn't set.
const envName =
	process.env.ENV_NAME && process.env.ENV_NAME.trim().length > 0 ? process.env.ENV_NAME : Environment.Local

export const enum Environment {
	"Local" = "Local",
	"Sandbox" = "Sandbox",
	"Production" = "LIVE",
}

// The dpscert deployment doesn't set a dedicated ENV_NAME, so we detect it by its host.
// TODO: replace this temporary URL-based check with a proper environment flag.
const DPSCERT_HOSTNAME = "app.dpscert.unit.co"

type EnvironmentName = "pilot" | "sandbox" | "live"

export function getCurrentEnvironment(): Environment {
	return envName as Environment
}

export function isLocalEnv() {
	return envName === Environment.Local
}

export function isSandboxEnv() {
	return envName === Environment.Sandbox
}

export function isProdEnv() {
	return envName === Environment.Production
}

export function isDpsCertEnv() {
	return typeof window !== "undefined" && window.location.hostname === DPSCERT_HOSTNAME
}

export function isSandboxOrLocalEnv() {
	return isSandboxEnv() || isLocalEnv()
}

// TEMPORARY: environments where the (still gated) Incoming RTP page is available:
// sandbox, the dpscert deployment, and local dev. Remove once RTP development is done.
export function isSandboxDpsCertOrLocalEnv() {
	return isSandboxEnv() || isDpsCertEnv() || isLocalEnv()
}

export function getCurrentEnvironmentName(): EnvironmentName {
	if (useIsOrgUnitPilot()) {
		return "pilot"
	}
	if (isProdEnv()) {
		return "live"
	}
	return "sandbox"
}

export const hotjarSetup = {id: 2933398, version: 6}
